<template>

        <time-picker-modal
                :init-hour="hour" :init-minute="minute" :init-selected="periodSelected"
                :handle-hour-change="handleHourChange" :handle-minute-change="handleMinuteChange"
                :handle-time-change="handleTimeChange"

        />

</template>

<script>
    import TimePickerModal from './TimePickerModal'
    export default {
        components: {
            TimePickerModal
        },
        props: {
            mode: {
                type: [String, Number],
                default: '24',
                validator: value => value == 24 || value == 12
            },
            defaultHour: {
                type: [String, Number],
                default: new Date().getHours(),
                validator: value => value >= 0 && value < 24
            },
            defaultMinute: {
                type: [String, Number],
                default: new Date().getMinutes(),
                validator: value => value >= 0 && value < 60
            },
            defaultFocused: {
                type: Boolean,
                default: false,
            },
            defaultSelected:{
                type:Array,
                default: function () {
                    return [new Date("July 21, 1983 01:15:00"),new Date("July 21, 1983 05:20:00"),new Date("July 21, 1983 03:25:00")]
                }
            },
            onFocusChange: {
                type: Function,
                default: () => {}
            },
            onHourChange: {
                type: Function,
                default: () => {}
            },
            onMinuteChange: {
                type: Function,
                default: () => {}
            },
            onTimeChange: {
                type: Function,
                default: () => {}
            }
        },
        data() {
            return {
                hour: this.defaultHour,
                minute: this.defaultMinute,
                picked:false,
                periodSelected:this.defaultSelected,
                focused: this.defaultFocused,
                overElement: false
            }
        },
        computed: {
            hourString() {
                return this.hour < 10 ? '0' + this.hour : this.hour + ''
            },
            minuteString() {
                return this.minute < 10 ? '0' + this.minute : this.minute + ''
            }
        },
        methods: {
            handleHourChange(hour,picked) {
                this.hour = hour
                this.picked = picked
                this.onHourChange && this.onHourChange(this.hour,this.picked)
                this.handleTimeChange({
                    hour: this.hour,
                    picked:this.picked,
                })

            },
            handleMinuteChange(minute,picked) {
                this.minute = minute
                this.picked = picked
                this.onMinuteChange && this.onMinuteChange(this.minute,this.picked)
                this.handleTimeChange({
                    minute: this.minute,
                    picked: this.picked,
                })
            },
            handleTimeChange(timeObj) {
                this.hour = timeObj['hour'] ? timeObj['hour'] : this.hour
                this.minute = timeObj['minute'] ? timeObj['minute'] : this.minute
                this.picked = timeObj['picked']
                this.onTimeChange && this.onTimeChange({
                    hour: this.hour,
                    minute: this.minute,
                    picked: this.picked,
                })
            }

        }
    }
</script>

<style lang="css">
</style>
